import { Combobox } from "@headlessui/react";
import { ChevronDown } from "lucide-react";
import { useState } from "react";

// `getOptionLabel` lets a caller show something other than the raw option —
// e.g. the FCT is stored as "Federal Capital Territory" but has to read as
// "Abuja (FCT)". Searching matches the option and its label, so typing
// "abuja" still finds it.
const DestinationCombobox = ({
  selectedState,
  setSelectedState,
  options,
  inputClassName,
  getOptionLabel = (option) => option,
}) => {
  const [query, setQuery] = useState("");

  const filteredStates =
    query === ""
      ? options
      : options.filter((state) =>
          `${state} ${getOptionLabel(state)}`
            .toLowerCase()
            .includes(query.toLowerCase())
        );

  return (
    <Combobox value={selectedState} onChange={setSelectedState}>
      {({ open }) => (
        <div className="relative">
          {/* INPUT */}
          <Combobox.Input
            className={`${inputClassName} pr-10`}
            displayValue={(state) => (state ? getOptionLabel(state) : "")}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search by State"
          />

          {/* BUTTON (HeadlessUI toggle trigger) */}
          <Combobox.Button className="absolute inset-y-0 right-3 flex items-center text-gray-500">
            <ChevronDown
              className={`h-4 w-4 transition-transform ${
                open ? "rotate-180" : ""
              }`}
            />
          </Combobox.Button>

          {/* OPTIONS */}
          {open && (
            <Combobox.Options className="absolute left-0 right-0 z-20 mt-2 max-h-56 overflow-auto rounded-2xl border border-[#d8dbe0] bg-white shadow-lg">
              {filteredStates.length === 0 ? (
                <div className="px-4 py-3 text-sm text-gray-500">
                  No results found
                </div>
              ) : (
                filteredStates.map((state) => (
                  <Combobox.Option
                    key={state}
                    value={state}
                    className={({ active }) =>
                      `cursor-pointer px-4 py-3 text-sm font-medium ${
                        active ? "bg-[#f4edef] text-gray-900" : "text-gray-800"
                      }`
                    }
                  >
                    {getOptionLabel(state)}
                  </Combobox.Option>
                ))
              )}
            </Combobox.Options>
          )}
        </div>
      )}
    </Combobox>
  );
};

export default DestinationCombobox;
